import script from "./SerializerErrorsToHTML.vue?vue&type=script&lang=js"
export * from "./SerializerErrorsToHTML.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__